"use client";

import _toConsumableArray from "/codebuild/output/src3481540116/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/codebuild/output/src3481540116/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useMenuList } from "../__chunks/ASGALOAX.js";
import { useMenuProviderContext } from "../__chunks/B2J376ND.js";
import "../__chunks/62UHHO2X.js";
import "../__chunks/T7VMP3TM.js";
import "../__chunks/ITI7HKP4.js";
import "../__chunks/5VQZOHHZ.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import { useHovercard } from "../__chunks/KQKDTOT4.js";
import "../__chunks/X7QOZUD3.js";
import "../__chunks/T6C2RYFI.js";
import { createDialogComponent } from "../__chunks/JC64G2H7.js";
import "../__chunks/63FEHJZV.js";
import "../__chunks/KZAQFFOU.js";
import "../__chunks/IGR4SXG2.js";
import "../__chunks/ESSM74HH.js";
import "../__chunks/BGQ3KQ5M.js";
import "../__chunks/YKJECYU7.js";
import "../__chunks/TOU75OXH.js";
import "../__chunks/WBDYNH73.js";
import "../__chunks/2PGBN2Y4.js";
import "../__chunks/63XF7ACK.js";
import "../__chunks/HLTQOHKZ.js";
import "../__chunks/677M2CI3.js";
import "../__chunks/6GXEOXGT.js";
import "../__chunks/AOUGVQZ3.js";
import "../__chunks/K2ZF5NU7.js";
import "../__chunks/ZWYATQFU.js";
import "../__chunks/5M6RIVE2.js";
import "../__chunks/O37CNYMR.js";
import "../__chunks/W3VI7GFU.js";
import "../__chunks/AOQQTIBO.js";
import "../__chunks/CZ4GFWYL.js";
import "../__chunks/VGCJ63VH.js";
import "../__chunks/XL7CSKGW.js";
import "../__chunks/EM5CXX6A.js";
import "../__chunks/MTZPJQMC.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import "../__chunks/LVA2YJMS.js";
import "../__chunks/SWN3JYXT.js";
import "../__chunks/XX67R432.js";
import { createElement, createHook, forwardRef } from "../__chunks/LMDWO4NN.js";
import "../__chunks/BM6PGYQY.js";
import "../__chunks/WYCIER3C.js";
import { useStoreState } from "../__chunks/YV4JVR4I.js";
import { useMergeRefs } from "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadProps, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/menu/menu.tsx
import { fireEvent } from "@ariakit/core/utils/events";
import { hasFocusWithin } from "@ariakit/core/utils/focus";
import { invariant, isFalsyBooleanCallback } from "@ariakit/core/utils/misc";
import { createRef, useEffect, useMemo, useRef, useState } from "react";
var TagName = "div";
var useMenu = createHook(function useMenu2(_a) {
  var _b = _a,
    store = _b.store,
    _b$modal = _b.modal,
    modalProp = _b$modal === void 0 ? false : _b$modal,
    _b$portal = _b.portal,
    portal = _b$portal === void 0 ? !!modalProp : _b$portal,
    _b$hideOnEscape = _b.hideOnEscape,
    _hideOnEscape = _b$hideOnEscape === void 0 ? true : _b$hideOnEscape,
    _b$autoFocusOnShow = _b.autoFocusOnShow,
    autoFocusOnShow = _b$autoFocusOnShow === void 0 ? true : _b$autoFocusOnShow,
    _hideOnHoverOutside = _b.hideOnHoverOutside,
    alwaysVisible = _b.alwaysVisible,
    props = __objRest(_b, ["store", "modal", "portal", "hideOnEscape", "autoFocusOnShow", "hideOnHoverOutside", "alwaysVisible"]);
  var context = useMenuProviderContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "Menu must receive a `store` prop or be wrapped in a MenuProvider component.");
  var ref = useRef(null);
  var parentMenu = store.parent;
  var parentMenubar = store.menubar;
  var hasParentMenu = !!parentMenu;
  var parentIsMenubar = !!parentMenubar && !hasParentMenu;
  props = __spreadProps(__spreadValues({}, props), {
    ref: useMergeRefs(ref, props.ref)
  });
  var _a2 = useMenuList(__spreadValues({
      store: store,
      alwaysVisible: alwaysVisible
    }, props)),
    ariaLabelledBy = _a2["aria-labelledby"],
    menuListProps = __objRest(_a2, ["aria-labelledby"]);
  props = menuListProps;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    initialFocusRef = _useState2[0],
    setInitialFocusRef = _useState2[1];
  var autoFocusOnShowState = store.useState("autoFocusOnShow");
  var initialFocus = store.useState("initialFocus");
  var baseElement = store.useState("baseElement");
  var items = store.useState("renderedItems");
  useEffect(function () {
    var cleaning = false;
    setInitialFocusRef(function (prevInitialFocusRef) {
      var _a3, _b2, _c;
      if (cleaning) return;
      if (!autoFocusOnShowState) return;
      if ((_a3 = prevInitialFocusRef == null ? void 0 : prevInitialFocusRef.current) == null ? void 0 : _a3.isConnected) return prevInitialFocusRef;
      var ref2 = createRef();
      switch (initialFocus) {
        case "first":
          ref2.current = ((_b2 = items.find(function (item) {
            return !item.disabled && item.element;
          })) == null ? void 0 : _b2.element) || null;
          break;
        case "last":
          ref2.current = ((_c = _toConsumableArray(items).reverse().find(function (item) {
            return !item.disabled && item.element;
          })) == null ? void 0 : _c.element) || null;
          break;
        default:
          ref2.current = baseElement;
      }
      return ref2;
    });
    return function () {
      cleaning = true;
    };
  }, [store, autoFocusOnShowState, initialFocus, items, baseElement]);
  var modal = hasParentMenu ? false : modalProp;
  var mayAutoFocusOnShow = !!autoFocusOnShow;
  var canAutoFocusOnShow = !!initialFocusRef || !!props.initialFocus || !!modal;
  var contentElement = useStoreState(store.combobox || store, "contentElement");
  var parentContentElement = useStoreState((parentMenu == null ? void 0 : parentMenu.combobox) || parentMenu, "contentElement");
  var preserveTabOrderAnchor = useMemo(function () {
    if (!parentContentElement) return;
    if (!contentElement) return;
    var role = contentElement.getAttribute("role");
    var parentRole = parentContentElement.getAttribute("role");
    var parentIsMenuOrMenubar = parentRole === "menu" || parentRole === "menubar";
    if (parentIsMenuOrMenubar && role === "menu") return;
    return parentContentElement;
  }, [contentElement, parentContentElement]);
  if (preserveTabOrderAnchor !== void 0) {
    props = __spreadValues({
      preserveTabOrderAnchor: preserveTabOrderAnchor
    }, props);
  }
  props = useHovercard(__spreadProps(__spreadValues({
    store: store,
    alwaysVisible: alwaysVisible,
    initialFocus: initialFocusRef,
    autoFocusOnShow: mayAutoFocusOnShow ? canAutoFocusOnShow && autoFocusOnShow : autoFocusOnShowState || !!modal
  }, props), {
    hideOnEscape: function hideOnEscape(event) {
      if (isFalsyBooleanCallback(_hideOnEscape, event)) return false;
      store == null ? void 0 : store.hideAll();
      return true;
    },
    hideOnHoverOutside: function hideOnHoverOutside(event) {
      var disclosureElement = store == null ? void 0 : store.getState().disclosureElement;
      var getHideOnHoverOutside = function getHideOnHoverOutside() {
        if (typeof _hideOnHoverOutside === "function") {
          return _hideOnHoverOutside(event);
        }
        if (_hideOnHoverOutside != null) return _hideOnHoverOutside;
        if (hasParentMenu) return true;
        if (!parentIsMenubar) return false;
        if (!disclosureElement) return true;
        if (hasFocusWithin(disclosureElement)) return false;
        return true;
      };
      if (!getHideOnHoverOutside()) return false;
      if (event.defaultPrevented) return true;
      if (!hasParentMenu) return true;
      if (!disclosureElement) return true;
      fireEvent(disclosureElement, "mouseout", event);
      if (!hasFocusWithin(disclosureElement)) return true;
      requestAnimationFrame(function () {
        if (hasFocusWithin(disclosureElement)) return;
        store == null ? void 0 : store.hide();
      });
      return false;
    },
    modal: modal,
    portal: portal,
    backdrop: hasParentMenu ? false : props.backdrop
  }));
  props = __spreadValues({
    "aria-labelledby": ariaLabelledBy
  }, props);
  return props;
});
var Menu = createDialogComponent(forwardRef(function Menu2(props) {
  var htmlProps = useMenu(props);
  return createElement(TagName, htmlProps);
}), useMenuProviderContext);
export { Menu, useMenu };